// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
import { AiFillCaretRight, AiFillCaretLeft } from 'react-icons/ai';
import './carousel.scss';

const CarouselTop = styled.div`
  background: #fff;
  .next {
    right: calc(50% - 475px);
    @media only screen and (max-width: 896px) {
      right: calc(50% - 355px);
    }
  }
  .prev {
    left: calc(50% - 475px);
    @media only screen and (max-width: 896px) {
      left: calc(50% - 355px);
    }
  }

  .slick-dots {
    bottom: -40px;
    @media only screen and (max-width: 896px) {
      bottom: -36px;
    }
  }

  .slick-dots li {
    @media only screen and (max-width: 896px) {
      width: 5px;
    }
  }

  .slick-dots li button:before {
    font-size: 40px;
    color: #b9b9b9;
    opacity: 1;
    @media only screen and (max-width: 896px) {
      font-size: 24px;
    }
  }

  .slick-dots li.slick-active button:before {
    color: #ce323a !important;
    opacity: 1;
    font-size: 50px;
    @media only screen and (max-width: 896px) {
      font-size: 32px;
      line-height: 20px;
    }
  }

  .slick-slide {
    position: relative;
    height: 500px;
    width: ${(props) => (props.quantity === 1 ? '100%' : '800px')};
    overflow: hidden;
    > div {
      height: 100%;
      > a {
        height: auto;
      }
    }
    @media only screen and (max-width: 896px) {
      width: ${(props) => (props.quantity === 1 ? '100%' : '600px')};
    }
    @media only screen and (max-width: 769px) {
      width: ${(props) => (props.quantity === 1 ? '100%' : '100vw')};
      height: 64vw;
    }
    /* @media only screen and (max-width: 480px) {
      width: 375px;
      height: 234px;
    } */
    img {
      width: 100%;
      height: auto;
    }
  }

  @media only screen and (max-width: 769px) {
    .slick-slide.slick-center img {
      opacity: 1;
    }
  }

  @media only screen and (min-width: 769px) {
    .slick-slide::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 3;
      background-color: rgba(0, 0, 0, 0);
      transition: 0.3s ease;
      pointer-events: none;
    }

    .slick-slide:not(.slick-current)::after {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
`;

export default function Carousel(props) {
  const { listBanner } = props;
  const NextArrow = ({ onClick }) => {
    return (
      <div className="arrow next" onClick={onClick}>
        <AiFillCaretRight size={50} style={{ fill: '#FFFFFF' }} />
      </div>
    );
  };
  const PrevArrow = ({ onClick }) => {
    return (
      <div className="arrow prev" onClick={onClick}>
        <AiFillCaretLeft size={50} style={{ fill: '#FFFFFF' }} />
      </div>
    );
  };

  const settings = {
    className: 'slider',
    dots: true,
    lazyLoad: true,
    infinite: true,
    centerMode: listBanner.length !== 1,
    variableWidth: true,
    adaptiveHeight: true,
    autoplay: listBanner.length !== 1,
    autoplaySpeed: 3000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <CarouselTop quantity={listBanner.length}>
      <Slider {...settings}>
        {listBanner.map((item, index) => {
          return (
            <a href={item.url_redirect} key={index}>
              <img
                src={item.image}
                className={listBanner?.length === 1 ? 'thumbnail-custom-top' : ''}
              />
            </a>
          );
        })}
      </Slider>
    </CarouselTop>
  );
}
